import { usePrice } from '@/store/price';
import { useShallow } from 'zustand/shallow';

export function usePriceByIndex(pairIndex: number | string) {
    const prices = usePrice(useShallow((state) => state.data));
    return Number(prices?.[pairIndex]?.price || '0');
}
